/**
 * group-users-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/";
import { MessageTag } from "../message-tag";

export class GroupUsersRequest extends ReplyVerifyingMessage
{
	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_GROUP_USERS;
	public static tag : MessageTag = MessageTag.REQ_GROUP_USERS;

	/**
	 * Construct a new {@link CreateGroupRequest}.
	 */
	constructor (
		public groupId : number
	)
	{
		super();
	}

	public verifyReply (reply : Message) : boolean
	{
		return Message.isA(reply, MessageTag.RSP_GROUP_USERS);
	}
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/group-users-request.ts